var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenguinBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ff6155",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.7 268.8L323.9 81.1 117.2 351.5l48.3 48.3-1.7 2 36.3 36.3-31.4 13.5 58.9 58.8a256 256 0 00284.1-241.6z",
    fill: "#ea0027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281 429h-50a96.5 96.5 0 01-95.6-109.6l25-182.8a96.5 96.5 0 01191.2 0l25 182.8c8 58-37.1 109.6-95.6 109.6z",
    fill: "#414952"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376.6 319.4l-25-182.8A96.5 96.5 0 00256 53v376h25a96.5 96.5 0 0095.6-109.7z",
    fill: "#23272b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M271.8 416.4h-31.6a61 61 0 01-60.3-69.1l15.7-115.5a61 61 0 01120.8 0L332 347.3a61 61 0 01-60.3 69.1z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M332.1 347.3l-15.7-115.5a61 61 0 00-60.4-52.6v237.2h15.8a61 61 0 0060.3-69.1z",
    fill: "#e9edf5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256 167.6l-27.7-44.5 4.1-4.2c13-13 34.2-13 47.2 0l4.1 4.2z",
    fill: "#fdba12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M283.7 123.1l-4.1-4.1c-6.5-6.5-15-9.8-23.6-9.8v58.4z",
    fill: "#ff9700"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.6,
    cy: 122.4,
    fill: "#bec3d2",
    r: 10.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.4,
    cy: 122.4,
    fill: "#7e8596",
    r: 10.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M354.2 155.2v212.9a58 58 0 0057.8-62.7l-31.2-133c-8-23.1-26.6-17.2-26.6-17.2z",
    fill: "#333940"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.8 155.2v212.9a58 58 0 01-57.8-62.7l31.2-133c8-23.1 26.6-17.2 26.6-17.2z",
    fill: "#555a66"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M343.3 451.6h-64.9a17 17 0 01-17-17v-10.8h54.1a27.7 27.7 0 0127.8 27.8z",
    fill: "#ff9700"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M168.7 451.6h64.9a17 17 0 0017-17v-10.8h-54.1a27.7 27.7 0 00-27.8 27.8z",
    fill: "#fdba12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenguinBadge);
export default __webpack_public_path__ + "static/media/penguin-badge.abcc0e58ae5dee7517ef939d42a52d8c.svg";
export { ForwardRef as ReactComponent };